/**
 * @fileoverview Dialog para adicionar novo ano
 * @module components/dre/AddYearDialog
 */

import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
} from '@mui/material';

import { useDREStore } from '../../stores/dreStore';

interface AddYearDialogProps {
  open: boolean;
  company: 'setima' | '555';
  existingYears: number[];
  onClose: () => void;
}

export function AddYearDialog({ open, company, existingYears, onClose }: AddYearDialogProps) {
  const [year, setYear] = useState('');
  const { addYear } = useDREStore();

  const handleAdd = () => {
    const yearNum = parseInt(year);
    
    if (isNaN(yearNum) || yearNum < 2000 || yearNum > 2050) {
      return;
    }
    
    if (existingYears.includes(yearNum)) {
      return;
    }
    
    addYear(company, yearNum);
    setYear('');
    onClose();
  };

  const handleClose = () => {
    setYear('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Adicionar Ano</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" mb={2}>
          Digite o ano que deseja adicionar à DRE:
        </Typography>
        <TextField
          autoFocus
          label="Ano"
          type="number"
          fullWidth
          value={year}
          onChange={(e) => setYear(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
          placeholder="Ex: 2025"
          inputProps={{
            min: 2000,
            max: 2050,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button onClick={handleAdd} variant="contained" disabled={!year}>
          Adicionar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
